import React from "react";
import { Mail, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-white py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_mindset-pro-2/artifacts/sp6dkiw7_Logo-PerfbyMind.png"
                alt="Performance by Mind"
                className="h-14 w-14 rounded-xl object-cover"
              />
              <div className="font-display text-2xl md:text-3xl font-black">
                Performance by Mind
              </div>
            </div>
            <p className="mt-4 text-base md:text-lg text-white/75 max-w-xl leading-relaxed">
              Accompagnement mental et consultation en psychologie du sport
              issus des sciences du sport (STAPS).
            </p>
            <p className="mt-3 text-xs md:text-sm text-white/55 max-w-xl leading-relaxed">
              Note&nbsp;: les prestations proposées relèvent de la préparation
              mentale et de l'optimisation de la performance, et ne se
              substituent pas à une prise en charge médicale ou psychologique
              (titre de psychologue protégé).
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Contact</div>
            <a
              href="mailto:perfbymind@gmail.com"
              data-testid="footer-email"
              className="flex items-center gap-2 text-base md:text-lg hover:text-[#9B8FE0] transition-colors"
            >
              <Mail size={16} /> perfbymind@gmail.com
            </a>
          </div>
          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Navigation</div>
            <ul className="space-y-2 text-base md:text-lg text-white/80">
              <li><a href="#about" className="hover:text-[#9B8FE0]">À propos</a></li>
              <li><a href="#services" className="hover:text-[#9B8FE0]">Services</a></li>
              <li><a href="#contact" className="hover:text-[#9B8FE0]">Contact</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Réseaux</div>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/perfbymind/" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#9B8FE0] hover:border-[#9B8FE0]"><Instagram size={16} /></a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-white/50">
          <div>© {new Date().getFullYear()} Léa Mistral — Performance by Mind. Tous droits réservés.</div>
          <div>Préparation mentale — France &amp; en visio</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
